import { memo } from 'react'

import { StoreOfferProduct, isStoreOfferProduct } from '@common'
import cx from 'classnames'

import { useOfferCountdown } from '@/features/products/useOfferCountdown'

import { CardFooter } from './CardFooter'
import { useGameSlug } from '../../game-provider'
import { BuyButton } from '../BuyButton/BuyButton'
import { TimeRemaining } from '../timeRemaining/TimeRemaining'

import styles from './cardOfferFooter.module.scss'

type Props = {
  product: StoreOfferProduct
  offerType?: 'offer' | 'bundle'
}

export const CardOfferFooter = memo(({ product, offerType }: Props) => {
  const gameSlug = useGameSlug()

  const { isTimedOffer, timeLeftText, countdownExpired } = useOfferCountdown({ product, threshold: 300 })

  const offerNotStarted =
    isStoreOfferProduct(product) && product.schedule !== null && product.schedule.purchaseStart > Date.now()

  const brawlBundle = gameSlug === 'brawlstars' && offerType === 'bundle'
  const royaleBundle = gameSlug === 'clashroyale' && offerType === 'bundle'

  return (
    <CardFooter className={cx(styles[gameSlug], offerType ? styles[offerType] : '')}>
      {isTimedOffer && timeLeftText.length > 0 && (
        <TimeRemaining timeLeftText={timeLeftText} type={brawlBundle || royaleBundle ? 'secondary' : 'primary'} />
      )}
      <BuyButton
        disabled={(isTimedOffer && countdownExpired) || offerNotStarted}
        variant={brawlBundle || royaleBundle ? 'Light' : 'Dark'}
        product={product}
        data-cy={`bundle-${product.id}`}
      />
    </CardFooter>
  )
})

CardOfferFooter.displayName = 'CardOfferFooter'
